import { IResponseProps } from '@/entities/Response'
import { IDoctorProps } from '@/entities/Doctor'

export const Types = {
  store: 'store',
  current: 'current',
  filter: 'filter'
}

export const path = 'doctor/'

export class Store implements FluxStandardAction<IResponseProps<IDoctorProps>> {
  type = path + Types.store
  constructor(public payload: IResponseProps<IDoctorProps>) {}
}

export class Current implements FluxStandardAction<IDoctorProps | null> {
  type = path + Types.current
  constructor(public payload: IDoctorProps | null) {}
}

export class Filter implements FluxStandardAction<string> {
  type = path + Types.filter
  constructor(public payload: string) {}
}
